module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new/_next/static/images/marquee-3-f4b30e9eebe01123f0c88fe286e14d27.png";